import { CSSProperties, ReactNode } from 'react'
import { Text } from '@quark/typography'
import Image from 'next/image'
import styles from './Hero.module.scss'

interface AwardProps {
  children: ReactNode
  className?: string
  style?: CSSProperties
}

const Award = ({ children, className, style }: AwardProps) => (
  <div className={[styles.award, className].filter(Boolean).join(' ')} style={style}>
    <Image
      className={styles.awardImage}
      src="https://acko-cms-dev.s3.ap-south-1.amazonaws.com/olive_Leaves_e9844beef8.svg"
      alt="left-leaves"
      height={54}
      width={22}
      loading="eager"
      fetchPriority="high"
    />
    <Text
      textAlign="center"
      fontStyle={{ lg: 'um_text-xl/medium', md: 'um_text-base/medium', sm: 'um_text-xs/medium' }}
      color="base/primary"
      whiteSpace="pre">
      {children}
    </Text>
    <Image
      className={`${styles.awardImage} ${styles.flip}`}
      src="https://acko-cms-dev.s3.ap-south-1.amazonaws.com/olive_Leaves_e9844beef8.svg"
      alt="left-leaves"
      height={54}
      width={22}
      loading="eager"
      fetchPriority="high"
    />
  </div>
)

export default Award
